const T = 0, o = "long";
export {
  o as INTL_MONTH_FORMAT,
  T as WEEK_START
};
//# sourceMappingURL=datepicker-constants.js.map
